@if (filteredUserTags$ | async; as filteredUserTags) {
  <div class="add-tag-block">
    @if (!dropdownBlockInfo.show && filteredUserTags.length) {
      <div class="add-item-block" [class.full-rounded]="noTagSelected">
        <button class="btn" (click)="clickAddNewTag($event)">
          <svg width="14" height="14" class="icon">
            <use xlink:href="#add-icon"></use>
          </svg>
        </button>
      </div>
    }
    @if (filteredUserTags.length) {
      @if (dropdownBlockInfo.show) {
        <app-user-tags-autocomplete-dropdown
          class="tags-autocomplete-dropdown"
          [sizeType]="dropdownSizeType"
          [holdDownSiblingsSelector]="holdDownSiblingsSelector"
          [holdDownSiblingsClass]="holdDownSiblingsClass"
          [autocompleteList]="filteredUserTags"
          (createTagFromAutocomplete)="onAddTag($event)"
          [showAllDropdownBlockInfo]="dropdownBlockInfo"></app-user-tags-autocomplete-dropdown>
      }
    } @else {
      <div class="add-item-block" [class.full-rounded]="noTagSelected">
        <a target="_blank" [routerLink]="['/user/tags']">
          <button class="btn">
            <svg width="14" height="14" class="icon">
              <use xlink:href="#add-icon"></use>
            </svg>
          </button>
        </a>
      </div>
    }
  </div>
}
